import React from "react";
import Page, { PageProps } from "../Page";
import { IReportingTypePresenter } from "../../../presenter/reporting/ReportingTypePresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import { Form } from "antd";
import CreateReportingTypeForm, {
  CreateReportingTypeFormProps
} from "./CreateReportingTypeForm";
import UpdateReportingTypeForm, {
  UpdateReportingTypeFormProps
} from "./UpdateReportingTypeForm";
import TickBox from "../../components/app/grid/TickBox";
import Loader from "../../components/Loader";
export interface Props extends PageProps {}
export interface State extends IReportingTypePresenter {}

export default class ReportingTypesPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    let {
      translate,
      reportingTypes = [],
      formTypesGroupCategories
    } = this.state;
    const CreateForm = Form.create<CreateReportingTypeFormProps>({})(
      CreateReportingTypeForm
    );

    const UpdateForm = Form.create<UpdateReportingTypeFormProps>({})(
      UpdateReportingTypeForm
    );

    const columns = [
      {
        title: translate("reporting_types_page.code"),
        dataIndex: "code",
        key: "code"
      },
      {
        title: translate("reporting_types_page.formTypesGroupCategoryCode"),
        dataIndex: "formTypesGroupCategoryCode",
        key: "formTypesGroupCategoryCode",
        width: "5%",
        align: "left"
      },

      {
        title: translate("reporting_types_page.name"),
        dataIndex: "name",
        key: "name"
      },
      {
        title: translate("reporting_types_page.description"),
        dataIndex: "description",
        key: "description"
      },
      {
        title: translate("reporting_types_page.data_input"),
        key: "dataInput",
        render: (record) => (
          <div>{`${record.period} ${record.periodMeasureUnit}`}</div>
        )
      },
      {
        title: translate("reporting_types_page.repeatingPeriod"),
        dataIndex: "repeatingPeriod",
        key: "repeatingPeriod",
        render: (text, record) => <TickBox value={record.repeatingPeriod} />,
        width: "5%"
      },
      {
        title: translate("reporting_types_page.periodOfRepetiton"),
        dataIndex: "periodOfRepetiton",
        key: "periodOfRepetiton",
        width: "130px",
        align: "left"
      },
      {
        title: translate("reporting_types_page.periodOfRepetitonMeasureUnit"),
        dataIndex: "periodOfRepetitonMeasureUnit",
        key: "periodOfRepetitonMeasureUnit",
        width: "130px",
        align: "left"
      },
      {
        title: translate("reporting_types_page.dateFrom"),
        dataIndex: "dateFrom",
        key: "dateFrom",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.dateFrom, b.dateFrom)
      },
      {
        title: translate("reporting_types_page.dateTo"),
        dataIndex: "dateTo",
        key: "dateTo",
        sorter: (a, b) =>
          DataGrid.SortHelper.compareDateString(a.dateTo, b.dateTo)
      },
      {
        title: translate("reporting_types_page.tag"),
        dataIndex: "tag",
        key: "tag"
      },
      {
        title: translate("reporting_types_page.gracePeriodInDays"),
        dataIndex: "gracePeriodInDays",
        key: "gracePeriodInDays",
        width: "150px",
        align: "left"
      },
      {
        title: translate("reporting_types_page.valid"),
        dataIndex: "valid",
        key: "valid",
        render: (text, record) => <TickBox value={record.valid} />,
        width: "75px"
      }
    ];

    const dataGrid = (
      <DataGrid
        title={translate("grids.reporting-types")}
        translate={translate}
        columns={columns}
        dataSource={reportingTypes}
        allowCreate={true}
        allowDelete={false}
        allowUpdate={true}
        createForm={CreateForm}
        codebooks={formTypesGroupCategories}
        onCreate={this.state.createReportingType}
        createModalTitle={translate("reporting_types_page.insert_modal_title")}
        updateForm={UpdateForm}
        updateModalTitle={translate("reporting_types_page.update_modal_title")}
        onUpdate={this.state.updateReportingType}
        addButtonText={translate("reporting_types_page.add_button_text")}
        booleanColumnKeys={["valid", "repeatingPeriod"]}
      />
    );
    return (
      <Page {...this.props}>
        <Loader
          children={dataGrid}
          translate={translate}
          loading={this.state.loaders.reportingTypesLoader}
        />
      </Page>
    );
  }
}
